module.exports = __webpack_public_path__ + "static/media/TRX.c98687e7.svg";